/** 带 token 时 401：清理会话前回调（如跳转登录、全局提示） */
let sessionExpiredHandler: (() => void) | undefined

export function setHttpSessionExpiredHandler(handler: (() => void) | undefined): void {
  sessionExpiredHandler = handler
}

export function notifyHttpSessionExpired(): void {
  sessionExpiredHandler?.()
}
